import { gql } from "@/gql";

export const RECENTLY_VIEWED_ITEMS = gql(`
  query RecentlyViewedItems($dealerAccountId: ID!) {
    recentlyViewedItems(dealerAccountId: $dealerAccountId) {
      contractId
      contractNumber
      customerId
      customerName
      dealerAccountId
      entityType
      iamDeviceId
      model
      purchaseOrderNumber
      quoteId
      serialNumber
      viewedAt
    }
  }
`);

export const RECORD_RECENTLY_VIEWED_ITEM = gql(`
  mutation RecordRecentlyViewedItem($input: RecordRecentlyViewedItemInput!) {
    recordRecentlyViewedItem(input: $input)
  }
`);
